import { clearAuthToken, isAuthenticated } from '../services/authService';
import { getObjectFromStorage, getStringFromStorage } from '../services/storageService';
import { redirectLoginWithTenantCode } from '../utils/amplify';
import { setAuthExpiryTime } from '../utils/auth';
import { flattenRow } from '../utils/featureUtils';
import { parseQuery } from '../utils/queryParse';
import { urlSafeDecode } from '@aws-amplify/core';

export const checkConfigDetailsInStorage = () => {
  const query: any = parseQuery(window.location.search);
  let tenantCode;
  if (query.state) {
    const isCustomStateIncluded = /-/.test(query.state);
    if (isCustomStateIncluded) {
      const customState: string = query.state.split('-').splice(1).join('-');
      tenantCode = urlSafeDecode(customState);
    }
  } else if (query.tenant_code) {
    tenantCode = query.tenant_code;
  }
  const tenant = getStringFromStorage('tenant');

  let amplifyConfig = {};
  if (tenantCode === tenant || isAuthenticated()) {
    amplifyConfig = getObjectFromStorage('amplifyConfig');
  }
  return { amplifyConfig, tenant };
};

export const maskLoginErrorMessages = (errObject) => {
  const { code, mode, message } = errObject;
  if (mode === 'Login' || mode === 'Reset') {
    if (
      ['UserNotFoundException', 'UserNotConfirmedException', 'InvalidParameterException'].includes(
        code,
      )
    ) {
      return `Your username ${mode !== 'Reset' ? 'or password' : ''} is incorrect. Please check and try again.`;
    } else if (code === 'NotAuthorizedException') {
      if (mode === 'NewPassword' || mode === 'Reset') {
        return 'Your password cannot be reset in the current state. Please contact your administrator.';
      } else if (mode === 'Login') {
        return 'Your username or password is incorrect. Please check and try again.';
      }
      return 'The application has encountered an unknown error. Please contact your system administrator.';
    }
  }
  return mode === 'Login'
    ? 'The application has encountered an unknown error. Please contact your system administrator.'
    : message;
};

export const genericLogout = (authLogout = null, navigate = null) => {
  const tenant = getStringFromStorage('tenant');

  if (authLogout && isAuthenticated()) {
    authLogout().then(() => {
      clearAuthToken();
      if (navigate) redirectLoginWithTenantCode(navigate, tenant);
    });
  } else {
    clearAuthToken();
    if (navigate) redirectLoginWithTenantCode(navigate, tenant);
  }
};

export const setAuthExpiryTimeFn = (history, token = null, authLogout = null, navigate = null) => {
  if (isAuthenticated()) {
    setAuthExpiryTime(token, history, (resolved) => {
      if (!resolved) {
        genericLogout(authLogout, navigate);
      }
    });
  } else {
    genericLogout(null, navigate);
  }
};

export const addNewEntries = (existingEntry: any, newEntries: any[]) => {
  const entries = JSON.parse(JSON.stringify(existingEntry));
  (newEntries || []).forEach((item) => {
    entries[item.id] = flattenRow(item);
  });
  return entries;
};
